const FLEXIBLE_URL_REGEX = /^(https?:\/\/|www\.)[^\s/$.?#].[^\s]*$/i;
const FLEXIBLE_URL_ERROR = 'Please enter a valid URL (e.g. https://example.com or www.example.com)';

const flexibleUrl = (schema) =>
  schema.test(
    'flexible-url',
    FLEXIBLE_URL_ERROR,
    (value) => !value || FLEXIBLE_URL_REGEX.test(value)
  );

export { flexibleUrl };
